<template>
  <div class="state control" :class="(tmp.isSilence ? 'isSilence' : '') + ' ' + (tmp.isIllegibly ? 'isIllegibly' : '')">
    <div class="title">
      <input type="text" class="answerTitle" :placeholder="$t('common.title')" v-model="tmp.title"/>

      <div class="windowButtons">
        <button class="delete" :aria-label="$t('common.actions.delete')" v-on:click="remove()"></button>
      </div>
    </div>

    <div class="wordsEditor">
      <div class="control" :class="tmp.isIntro ? 'hide-input' : ''">
        <label class="checkbox isSilence"><input type="checkbox" v-model="tmp.isSilence" class="isSilence checkbox"/>{{$t('scenarios.konstruktor.canvas.answer.silence')}}</label>
        <label class="checkbox isIllegibly"><input type="checkbox" v-model="tmp.isIllegibly" class="isIllegibly checkbox"/>{{$t('scenarios.konstruktor.canvas.answer.anotherAnswer')}}</label>
      </div>

      <vue-tags v-model="tmp.tags" :class="tmp.isIntro ? 'hide-input' : ''">
        <div class="tags-input tags are-medium" slot-scope="{tag,removeTag,inputEventHandlers,inputBindings }">
          <div class="control autocomplete">
            <input
              class="tags-input-text input"  :placeholder="$t('scenarios.konstruktor.canvas.answer.synonyms.addWord') + '...'"
              v-on="inputEventHandlers"
              v-bind="inputBindings"
            />

<!--            <button type="button" class="button addForAll" v-on:click="addWordsForAllByTitle(tmp)" title="добавить для всех с таким же title"><i class="fas fa-copy"></i></button>-->
          </div>
          <button type="button" class="button addForAll" v-on:click="addWordsForAllByTitle(tmp)" :title="$t('scenarios.konstruktor.canvas.answer.synonyms.addForAllWithSameTitle')"><i class="fas fa-copy"></i></button>
          <span v-for="tag in tmp.tags" class="tags-input-tag tag is-medium">
           {{ tag }}
           <button type="button" class="tags-input-remove delete" v-on:click="removeTag(tag)"></button>
         </span>
        </div>
      </vue-tags>
      <div class="button-group" role="group" v-if="tmp.isIntro">
        <button class="button choose-state" type="button" v-on:click="setApprove()">{{ $t('scenarios.konstruktor.canvas.answer.approve') }}</button>
        <button class="button choose-state" type="button" v-on:click="setDeny()">{{ $t('scenarios.konstruktor.canvas.answer.deny') }}</button>
        <button class="button choose-state" type="button" v-on:click="setSilence()">{{ $t('scenarios.konstruktor.canvas.answer.silence') }}</button>
        <button class="button choose-state" type="button" v-on:click="setIllegibly()">{{ $t('scenarios.konstruktor.canvas.answer.illegibly') }}</button>
        <button class="button choose-state" type="button" v-on:click="setCustom()">{{ $t('scenarios.konstruktor.canvas.answer.custom') }}</button>
      </div>
    </div>

  </div>

</template>


<script>

    import BaseComponent from '../BaseComponent'
    import VueTags from 'vue-tags'
    import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
    import {standardSynonyms as importedStandardSynonyms} from './standardSynonyms'
    import itemTemplate from './suggestion-item-template.vue'
    import {autocomplete} from './utils'

    export default {
        name: 'InOutState',
        extends: BaseComponent,
        props: ['answerTitle', 'answerStateQuestion', 'answerStateValue', 'answerWords', 'remove', 'addWordsForAllByTitle', 'answerIsSilence', 'answerIsIllegibly', 'answerRecognitionDriver'],
        components: {
            VueTags,
            Collapse,
            CollapseItem
        },
        methods:{
            setSilence() {
              this.tmp.isIntro = false
              this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.silence')
              this.tmp.isSilence = true
            },
            setIllegibly() {
              this.tmp.isIntro = false
              this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.illegibly')
              this.tmp.isIllegibly = true
            },
            setCustom() {
              this.tmp.isIntro = false
              this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.custom')
            },
            setApprove() {
              this.tmp.isIntro = false
              this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.approve')
              let approveSynonyms = this.standardSynonyms.find(el => el.name.toLowerCase() === this.$t('common.yes').toLowerCase())
              for (let i = 0; i < approveSynonyms.words.length; i++) {
                this.tmp.tags.push('' + approveSynonyms.words[i])
              }
            },
            setDeny() {
              this.tmp.isIntro = false
              this.tmp.title = this.$t('scenarios.konstruktor.canvas.answer.deny')
              let denySynonyms = this.standardSynonyms.find(el => el.name.toLowerCase() === this.$t('common.no').toLowerCase())
              for (let i = 0; i < denySynonyms.words.length; i++) {
                this.tmp.tags.push('' + denySynonyms.words[i])
              }
            }
        },
        data() {
            return {
                tmp: {
                    title: '',
                    stateValue: '',
                    stateQuestion: '',
                    tags: [],
                    isSilence: false,
                    isIllegibly: false,
                    isIntro: true
                },
              suggestionItems: [],
              suggestionItem: '',
              itemTemplate,
              standardSynonyms: importedStandardSynonyms
            }
        },
        mounted() {
            this.tmp.title = '' + (this._props.answerTitle || '')
            this.tmp.stateValue = '' + (this._props.answerStateValue || '')
            this.tmp.stateQuestion = '' + (this._props.answerStateValue || '')
            let tags = []
            if (this._props.answerWords) {
                for (let i = 0; i < this._props.answerWords.length; i++) {
                    tags.push('' + this._props.answerWords[i])
                }
            }
            this.tmp.tags = tags
            this.tmp.isSilence = this._props.answerIsSilence
            this.tmp.isIllegibly = this._props.answerIsIllegibly

            if (this.tmp.isSilence || this.tmp.isIllegibly || this.tmp.tags.length !== 0) {
                this.tmp.isIntro = false
            }

            // this.$el.querySelector('.suggestionDiv input').classList.add('input')
            let that = this
            autocomplete(this.$el.querySelector('input.tags-input-text'), this.standardSynonyms, 64, function(words) {
              for (let j = 0; j < words.length; j++) {
                let word = words[j]
                if (!that.tmp.tags.includes(word)) {
                  that.tmp.tags.push(word)
                }
              }
            })
        }
    }
</script>

<style scoped>
  .title .answerTitle {
    overflow-x: hidden;
    padding-right: 4px;
    display: inline-block;
    font-weight: bold;
    border: none;
    background-color: transparent;
    max-width: 240px;
    font-size: large;
  }

  .title .delete {
    background-color: indianred;
    margin-left: 16px;
  }
  .title {
    font-size: medium;
    margin-bottom: 8px;
  }
  .windowButtons {
    float: right;
    display: inline-block;
  }
  .tags .tag {
    cursor: text;
  }
  .wordsEditor {
    overflow-y: scroll;
    height:256px;
  }

  .wordsEditor .collapse {
    width: 99%;
  }

  .wordsEditor .collapse .collapse-item{
    background-color: unset;
    box-shadow: unset;
  }



  .wordsEditor .collapse .collapse-item .card-content {
    margin-top: -38px;
  }

  .wordsEditor .addForAll {
    margin:0;
  }

  .isSilence .tags, .isIllegibly .tags {
    display:none;
  }

  .suggestionDiv input {
    border-radius: unset;
    width: 90%;
  }

  .vue-suggestion .vs__list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #023d7b;
    position: relative;
  }
  .vue-suggestion .vs__list .vs__list-item {
    background-color: #fff;
    padding: 10px;
    border-left: 1px solid #023d7b;
    border-right: 1px solid #023d7b;
  }
  .vue-suggestion .vs__list .vs__list-item:last-child {
    border-bottom: none;
  }
  .vue-suggestion .vs__list .vs__list-item:hover {
    background-color: #eee !important;
  }
  .vue-suggestion .vs__list,
  .vue-suggestion .vs__loading {
    position: absolute;
  }
  .vue-suggestion .vs__list .vs__list-item {
    cursor: pointer;
  }
  .vue-suggestion .vs__list .vs__list-item.vs__item-active {
    background-color: #f3f6fa;
  }
</style>

<style>
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #023d7b;
    position: relative;
    z-index: 1000;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list .vs__list-item {
    background-color: #fff;
    padding: 10px;
    border-left: 1px solid #023d7b;
    border-right: 1px solid #023d7b;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list .vs__list-item:last-child {
    border-bottom: none;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list .vs__list-item:hover {
    background-color: #eee !important;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list,
  #Konstruktor .inOutState_shell .vue-suggestion .vs__loading {
    position: absolute;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list .vs__list-item {
    cursor: pointer;
  }
  #Konstruktor .inOutState_shell .vue-suggestion .vs__list .vs__list-item.vs__item-active {
    background-color: #f3f6fa;
  }

  .autocomplete {
    /* the container must be positioned relative: */
    position: relative;
    display: inline-block;
  }
  .autocomplete-items {
    position: absolute;
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    /* position the autocomplete items to be the same width as the container: */
    top: 100%;
    left: 0;
    right: 0;
  }
  .autocomplete-items div {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
  }
  .autocomplete-items div:hover {
    /* when hovering an item: */
    background-color: #e9e9e9;
  }
  .autocomplete-active {
    /* when navigating through the items using the arrow keys: */
    background-color: DodgerBlue !important;
    color: #ffffff;
  }

  .driver label {
    vertical-align: bottom;
    line-height: 30px;
  }

  .button-group{
    margin: auto;
    text-align: center;
    padding:10px;
  }
  .choose-state{
    width: 90%;
  }
  .hide-input{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// InOutState.vue?76d8bb84